import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function CheckDeleteClient({ setOverlay, clientId, btoa }) {
  const [deleteClientStatus, setDeleteClientStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  let navigate = useNavigate();
  const deleteClientFunction = async () => {
    try {
      const clientsData = await fetch(
        `${process.env.REACT_APP_BASE_URL}/client/${clientId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa,
          },
        }
      );

      if (clientsData?.status === 204) {
        window.location.reload();
      }
    } catch (error) {
      console.log(console.error);
      setErrorMessage(true);
    }
  };
  return (
    <div className="check">
      {errorMessage === true ? (
        <p className="warning-text">
          An error occured, please try again later.
        </p>
      ) : (
        <>
          <p className="warning-text">Are you sure you want to delete this?</p>
          <div className="buttons">
            <button
              className="yes-btn"
              onClick={() => {
                deleteClientFunction();
                setDeleteClientStatus(true);
              }}
            >
              Yes
              <span
                className={`${
                  deleteClientStatus === false
                    ? ""
                    : "spinner-border spinner-border-sm"
                } `}
                style={{ marginLeft: "5px" }}
              ></span>
            </button>
            <button
              className="no-btn"
              onClick={() => {
                setOverlay(false);
              }}
            >
              No
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default CheckDeleteClient;
